/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Chip
} from '@mui/material';
import { formatDate } from 'utils/formatters';

const AcquittalLineActivitiesFinanceTable = ({ lineActivities, formatCurrency }) => {
    // Calculate totals
    const totals = lineActivities.reduce(
        (acc, activity) => ({
            breakfast: acc.breakfast + (activity.breakfast || 0),
            lunch: acc.lunch + (activity.lunch || 0),
            dinner: acc.dinner + (activity.dinner || 0),
            incidental: acc.incidental + (activity.incidental || 0),
            accommodation: acc.accommodation + (activity.accommodation || 0),
            miscellaneous: acc.miscellaneous + (activity.miscellaneous || 0)
        }),
        {
            breakfast: 0,
            lunch: 0,
            dinner: 0,
            incidental: 0,
            accommodation: 0,
            miscellaneous: 0
        }
    );

    const grandTotal = Object.values(totals).reduce((sum, value) => sum + value, 0);

    return (
        <TableContainer component={Paper} sx={{ mt: 2, borderRadius: 2, boxShadow: 3 }}>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: 'primary.main' }}>
                        <TableCell sx={{ color: 'white', fontWeight: 600 }}>Date</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Breakfast</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Lunch</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Dinner</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Incidental</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Accommodation</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Miscellaneous</TableCell>
                        <TableCell align="right" sx={{ color: 'white', fontWeight: 600 }}>Daily Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {lineActivities.map((activity) => {
                        const dailyTotal =
                            (activity.breakfast || 0) +
                            (activity.lunch || 0) +
                            (activity.dinner || 0) +
                            (activity.incidental || 0) +
                            (activity.accommodation || 0) +
                            (activity.miscellaneous || 0);

                        return (
                            <TableRow
                                key={activity.id}
                                sx={{
                                    '&:nth-of-type(odd)': { backgroundColor: 'action.hover' },
                                    '&:hover': { backgroundColor: 'action.selected' }
                                }}
                            >
                                <TableCell>
                                    <Typography variant="body2" fontWeight={500}>
                                        {formatDate(activity.activityDate)}
                                    </Typography>
                                </TableCell>
                                <TableCell align="right">{formatCurrency(activity.breakfast)}</TableCell>
                                <TableCell align="right">{formatCurrency(activity.lunch)}</TableCell>
                                <TableCell align="right">{formatCurrency(activity.dinner)}</TableCell>
                                <TableCell align="right">{formatCurrency(activity.incidental)}</TableCell>
                                <TableCell align="right">{formatCurrency(activity.accommodation)}</TableCell>
                                <TableCell align="right">{formatCurrency(activity.miscellaneous)}</TableCell>
                                <TableCell align="right">
                                    <Chip
                                        label={formatCurrency(dailyTotal)}
                                        color="primary"
                                        size="small"
                                        sx={{ fontWeight: 600 }}
                                    />
                                </TableCell>
                            </TableRow>
                        );
                    })}
                    <TableRow sx={{ backgroundColor: 'grey.100' }}>
                        <TableCell sx={{ fontWeight: 600 }}>Totals</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(totals.breakfast)}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(totals.lunch)}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(totals.dinner)}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(totals.incidental)}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(totals.accommodation)}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>{formatCurrency(totals.miscellaneous)}</TableCell>
                        <TableCell align="right">
                            <Chip
                                label={formatCurrency(grandTotal)}
                                color="primary"
                                variant="filled"
                                sx={{ fontWeight: 700 }}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

AcquittalLineActivitiesFinanceTable.propTypes = {
    lineActivities: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            activityDate: PropTypes.string.isRequired,
            breakfast: PropTypes.number,
            lunch: PropTypes.number,
            dinner: PropTypes.number,
            incidental: PropTypes.number,
            accommodation: PropTypes.number,
            miscellaneous: PropTypes.number
        })
    ).isRequired,
    formatCurrency: PropTypes.func.isRequired
};

export default AcquittalLineActivitiesFinanceTable; 